import ContentService from "../services/content";
import * as types from "../actions/ActionTypes";
// import _ from "lodash";
import { store } from "../storage/store";
import axios from "axios";

export const test = async () => {
  try {
    const response = await axios.get(
      "https://s3.amazonaws.com/pro-flixxo-assets/contents-subtitle/1565278046009"
    );

    return response;
  } catch (error) {
  }
};

const tenMinutes = 600000;

export const query = (params) => {
  const secret = store.getState().authReducer.secret;
  const service = new ContentService(secret);

  return {
    type: types.CONTENTS,
    payload: service["query"](params),
  };
};

export const get = (params) => {
  const secret = store.getState().authReducer.secret;
  const service = new ContentService(secret);

  return {
    type: types.CONTENT,
    payload: service["get"](params),
  };
};

export const checkMedia = (hash) => {
  const secret = store.getState().authReducer.secret;
  const service = new ContentService(secret);

  return async (dispatch) => {
    return dispatch({
      type: types.CONTENT_CHECK_MEDIA,
      payload: service["checkMedia"](hash),
    }).then((res) => {
      return res;
    });
  };
};

// export const getByCategory = (params) => {
//   const secret = store.getState().authReducer.secret;
//   const service = new ContentService(secret);
//   let { contentsByCategory, filter } = store.getState().contentReducer;
//   let result;
//   let toFilter = _.map(contentsByCategory, (cbc, key) => {
//     if (key === filter) {
//       return cbc;
//     } else {
//       return undefined;
//     }
//   });
//   let obj = _.filter(toFilter, (tf) => tf !== undefined);
//   if (_.isEmpty(contentsByCategory[filter])) {
//     result = {
//       type: types.CONTENTS_BY_CATEGORY,
//       payload: service["getByCategory"](params),
//     };
//   } else if (obj.length === 0) {
//     result = {
//       type: types.CONTENTS_BY_CATEGORY,
//       payload: service["getByCategory"](params),
//     };
//   } else if (obj[0][params.id] === undefined) {
//     result = {
//       type: types.CONTENTS_BY_CATEGORY,
//       payload: service["getByCategory"](params),
//     };
//   } else if (new Date().getTime() - obj[0][params.id].timestamp < tenMinutes) {
//     result = {
//       type: types.CONTENTS_BY_CATEGORY,
//       payload: Promise.resolve(contentsByCategory[filter][params.id].payload),
//     };
//   } else if (new Date().getTime() - obj[0][params.id].timestamp > tenMinutes) {
//     result = {
//       type: types.CONTENTS_BY_CATEGORY,
//       payload: service["getByCategory"](params),
//     };
//   }
//   return result;
// };

export const getByUser = (params) => {
  const secret = store.getState().authReducer.secret;
  const service = new ContentService(secret);

  return {
    type: types.CONTENTS_BY_USER,
    payload: service["getByUser"](params),
  };
};

export const resetSelectedItem = () => {
  return {
    type: types.SELECTED_ITEM_RESET,
  };
};

export const getByIds = (ids) => {
  const secret = store.getState().authReducer.secret;
  const service = new ContentService(secret);
  const promises = ids.map((id) => {
    return service["get"](id);
  });

  return {
    type: types.CONTENTS_BY_IDS,
    payload: Promise.all(promises),
  };
};

export const reset = () => {
  return {
    type: types.CONTENT_RESET,
  };
};

export const post = (params) => {
  const secret = store.getState().authReducer.secret;
  const service = new ContentService(secret);

  return {
    type: types.CONTENT_POST,
    payload: service["post"](params),
  };
};

export const _delete = (params) => {
  const secret = store.getState().authReducer.secret;
  const service = new ContentService(secret);

  return {
    type: types.CONTENT_DELETE,
    payload: service["delete"](params),
  };
};

export const setContentToEdit = (content) => {
  return {
    type: types.SET_CONTENT_TO_EDIT,
    payload: content,
  };
}

export const uploadContentSetCurrentStep = (step) => {
  return {
    type: types.SET_CURRENT_STEP,
    payload: step
  };
}

export const video = (video) => {
  return {
    type: types.CONTENT_VIDEO,
    payload: video,
  };
};

export const videoReset = () => {
  return {
    type: types.CONTENT_VIDEO_RESET,
  };
};

export const hash = (hash) => {
  return {
    type: types.CONTENT_HASH,
    payload: hash,
  };
};

export const hashReset = () => {
  return {
    type: types.CONTENT_HASH_RESET,
  };
};

export const uploadInformation = (params) => {
  return {
    type: types.CONTENT_UPLOAD_INFORMATION,
    payload: params,
  };
};

export const playContent = (param) => {
  return {
    type: types.CONTENT_PLAY,
    payload: param,
  };
};

export const pauseContent = () => {
  return {
    type: types.CONTENT_PAUSE,
  };
};

export const openBuyContent = (param) => {
  return {
    type: types.CONTENT_OPEN_BUY_MODAL,
  };
};

export const closeBuyContent = () => {
  return {
    type: types.CONTENT_CLOSE_BUY_MODAL,
  };
};

export const progressByHttp = (param) => {
  return {
    type: types.CONTENT_PROGRESS_BY_HTTP,
    payload: param,
  };
};

export const getContentRevisions = (uuid) => {
  const secret = store.getState().authReducer.secret;
  const service = new ContentService(secret);
  return {
    type: types.CONTENT_REVISION_TOP,
    payload: service["getContentRevisions"](uuid),
  };
};

export const togglePlayer = () => {
  return {
    type: types.TOGGLE_MAIN_PLAYER,
  };
};

export const setMainPlayer = (player) => {
  return {
    type: types.MAIN_PLAYER,
    payload: player,
  };
};

export const setMainPlayerVideoUuid = (uuid) => {
  return {
    type: types.MAIN_PLAYER_VIDEO_UUID,
    payload: uuid,
  };
};

export const setMainPlayerContentType = (contentType) => {
  return {
    type: types.MAIN_PLAYER_CONTENTTYPE,
    payload: contentType,
  };
};

export const setMainPlayerVideoSub = (sub) => {
  return {
    type: types.MAIN_PLAYER_VIDEO_SUB,
    payload: sub,
  };
};

export const setMainPlayerVideoHash = (hash) => {
  return {
    type: types.MAIN_PLAYER_HASH,
    payload: hash,
  };
};

export const setSerie = (params) => {
  return {
    type: types.CONTENT_SERIE,
    payload: params,
  };
};

export const setSerieDraft = (params) => {
  return {
    type: types.CONTENT_SERIE_DRAFT,
    payload: params,
  };
};

export const resetSerieDraft = () => {
  return {
    type: types.CONTENT_SERIE_DRAFT_RESET,
  };
};

export const getSerieById = (uuid) => {
  const secret = store.getState().authReducer.secret;
  const service = new ContentService(secret);
  return {
    type: types.CONTENT_SERIE_BY_ID,
    payload: service["getSerieById"](uuid),
  };
};

export const getSeriesByIds = (ids) => {
  const secret = store.getState().authReducer.secret;
  const service = new ContentService(secret);
  const promises = ids.map((id) => {
    return service["getSerieById"](id);
  });

  return {
    type: types.SERIES_BY_IDS,
    payload: Promise.all(promises),
  };
};

export const resetSerie = () => {
  return {
    type: types.CONTENT_SERIE_RESET,
  };
};

export const getTorrentFile = (uuid) => {
  const secret = store.getState().authReducer.secret;
  const service = new ContentService(secret);
  return {
    type: types.CONTENT_TORRENT_FILE,
    payload: service["getTorrentFile"](uuid),
  };
};

export const getWebLink = (uuid) => {
  const secret = store.getState().authReducer.secret;
  const service = new ContentService(secret);
  return {
    type: types.CONTENT_TORRENT_WEB_LINK,
    payload: service["getWebLink"](uuid),
  };
};

export const postSubtitles = (subtitle) => {
  const secret = store.getState().authReducer.secret;
  const service = new ContentService(secret);
  return {
    type: types.CONTENT_UPLOAD_SUBTITLE,
    payload: service["postSubtitles"](subtitle),
  };
};
export const postGeoblocking = (geoblocking) => {
  const secret = store.getState().authReducer.secret;
  const service = new ContentService(secret);
  return {
    type: types.CONTENT_UPDATE_GEOBLOCKING,
    payload: service["postGeoblocking"](geoblocking),
  };
};
export const deleteGeoblocking = (geoblocking) => {
  const secret = store.getState().authReducer.secret;
  const service = new ContentService(secret);
  return {
    type: types.CONTENT_DELETE_GEOBLOCKING,
    payload: service["deleteGeoblocking"](geoblocking),
  };
};
export const getGeoblocking = (geoblocking) => {
  const secret = store.getState().authReducer.secret;
  const service = new ContentService(secret);
  return {
    type: types.CONTENT_GET_GEOBLOCKING_SERIE,
    payload: service["getGeoblocking"](geoblocking),
  };
};
export const postGeoblockingSerie = (geoblocking) => {
  const secret = store.getState().authReducer.secret;
  const service = new ContentService(secret);
  return {
    type: types.CONTENT_UPDATE_GEOBLOCKING_SERIE,
    payload: service["postGeoblockingSerie"](geoblocking),
  };
};
export const deleteGeoblockingSerie = (geoblocking) => {
  const secret = store.getState().authReducer.secret;
  const service = new ContentService(secret);
  return {
    type: types.CONTENT_DELETE_GEOBLOCKING_SERIE,
    payload: service["deleteGeoblockingSerie"](geoblocking),
  };
};
export const getGeoblockingSerie = (geoblocking) => {
  const secret = store.getState().authReducer.secret;
  const service = new ContentService(secret);
  return {
    type: types.CONTENT_GET_GEOBLOCKING_SERIE,
    payload: service["getGeoblockingSerie"](geoblocking),
  };
};

export const updateCoverSerie = (data) => {
  const secret = store.getState().authReducer.secret;
  const service = new ContentService(secret);
  return {
    type: types.SERIE_UPDATE_COVER,
    payload: service["updateCoverSerie"](data),
  };
};

export const updateMetadataSerie = (data) => {
  const secret = store.getState().authReducer.secret;
  const service = new ContentService(secret);
  return {
    type: types.SERIE_UPDATE_METADATA,
    payload: service["updateMetadataSerie"](data),
  };
};

export const deleteEpisodes = (params) => {
  const secret = store.getState().authReducer.secret;
  const service = new ContentService(secret);
  return {
    type: types.CONTENT_DELETE_EPISODES,
    payload: service["deleteEpisodes"](params),
  };
};

export const reorderEpisodes = (params) => {
  const secret = store.getState().authReducer.secret;
  const service = new ContentService(secret);
  return {
    type: types.CONTENT_REORDER_EPISODES,
    payload: service["reorderEpisodes"](params),
  };
};

export const changeCommunityFilterContent = (param) => {
  return {
    type: types.CHANGE_COMMUNITY_FILTER_CONTENT,
    payload: param,
  };
};

export const setCurrentContentForLanding = (content) => {
  return {
    type: types.SET_CURRENT_CONTENT,
    payload: content,
  };
};

export const setCurrentSerieForLanding = (content) => {
  return {
    type: types.SET_CURRENT_SERIE,
    payload: content,
  };
};

export const removeCurrentSerieForLanding = () => {
  return {
    type: types.REMOVE_CURRENT_SERIE,
  };
};

export const removeCurrentContentForLanding = () => {
  return {
    type: types.REMOVE_CURRENT_CONTENT,
  };
};

export const setContentWeblinkURL = (url) => {
  return {
    type: types.SET_CONTENT_WEBLINK,
    payload: url,
  };
};

export const toSetContentWeblinkURL = (url) => {
  return {
    type: types.SET_CONTENT_WEBLINK,
    payload: url,
  };
};
export const removeContentWeblinkURL = () => {
  return {
    type: types.REMOVE_CONTENT_WEBLINK,
  };
};
export const setCarrouselForLanding = (id, type) => {
  return {
    type: types.SET_CARROUSEL_FOR_LANDING,
    payload: { id, type },
  };
};

export const removeCarrouselForLanding = () => {
  return {
    type: types.REMOVE_CARROUSEL_FOR_LANDING,
  };
};

export const setVideoSubtitles = (subtitles) => {
  return {
    type: types.SET_VIDEO_SUBTITLES,
    payload: subtitles,
  };
};

export const removeVideoSubtitles = () => {
  return {
    type: types.REMOVE_VIDEO_SUBTITLES,
  };
};

export const setMeta = meta => {
  return {
    type: types.UPLOAD_CONTENT_META,
    payload: meta
  };
};

export const setCategory = category => {
  return {
    type: types.UPLOAD_CONTENT_CATEGORY,
    payload: category
  };
};

export const setTags = tags => {
  return {
    type: types.UPLOAD_CONTENT_TAGS,
    payload: tags
  };
};

export const setRating = rating => {
  return {
    type: types.UPLOAD_CONTENT_RATING,
    payload: rating
  };
};

export const uploadContentCover = cover => {
  return {
    type: types.UPLOAD_CONTENT_COVER,
    payload: cover
  };
};

export const setSubtitle = subtitle => {
  return {
    type: types.UPLOAD_CONTENT_SUBTITLE,
    payload: subtitle
  };
};

export const setAudioLang = audioLang => {
  return {
    type: types.UPLOAD_CONTENT_AUDIO_LANG,
    payload: audioLang
  };
};

export const setAuthorFee = price => {
  return {
    type: types.UPLOAD_CONTENT_PRICE,
    payload: price
  };
};

export const setSeederFee = distribution => {
  return {
    type: types.UPLOAD_CONTENT_DISTRIBUTION,
    payload: distribution
  };
};

export const getContentUploadUUID = async () => {
  const secret = store.getState().authReducer.secret;
  const service = new ContentService(secret);
  return {
    type: types.GET_CONTENT_UPLOAD_UUID,
    payload: await service["getContentUploadUUID"]()
  };
};

export const uploadContentCoverPost = async (contentUploadUUID, cover) => {
  const secret = store.getState().authReducer.secret;
  const service = new ContentService(secret);
  return {
    type: types.UPLOAD_CONTENT_COVER_POST,
    payload: await service["uploadContentCover"](contentUploadUUID, cover)
  };
};

export const uploadContentDetailsPost = async (contentUploadUUID, details) => {
  const secret = store.getState().authReducer.secret;
  const service = new ContentService(secret);
  return {
    type: types.UPLOAD_CONTENT_DETAILS_POST,
    payload: await service["uploadContentDetails"](contentUploadUUID, details)
  };
};

export const uploadContentSubutitlesPost = async (contentUploadUUID, subtitles) => {
  const secret = store.getState().authReducer.secret;
  const service = new ContentService(secret);
  return {
    type: types.UPLOAD_CONTENT_SUBTITLES_POST,
    payload: await service["uploadContentSubtitles"](contentUploadUUID, subtitles)
  };
};

export const uploadContentReset = () => {
  return {
    type: types.RESET_UPLOAD_CONTENT
  };
};

export const getDRMToken = async (contentUUID, typeDRM) => {
  const secret = store.getState().authReducer.secret;
  const service = new ContentService(secret);
  return {
    type: types.GET_DRM_TOKEN,
    payload: await service["getDRMToken"](contentUUID, typeDRM)
  };
};

export const getManifest = async (contentUUID, typeDRM) => {
  const secret = store.getState().authReducer.secret;
  const service = new ContentService(secret);
  return {
    type: types.GET_MANIFEST,
    payload: await service["getManifest"](contentUUID, typeDRM)
  };
};

export const setContentToShow = (params) => {
  return {
    type: types.SET_CONTENT_TO_SHOW,
    payload: params
  };
}